import React from 'react';
import { RefreshCw, Loader } from 'lucide-react';

export default function RefinementPanel({ signals, onRefine, loading }) {
  const total = signals.size;
  const relevant = [...signals.values()].filter(v => v === 'relevant').length;
  const offTopic = [...signals.values()].filter(v => v === 'off_topic').length;
  const canRefine = total >= 5 && !loading;

  return (
    <div className="fs-refine-panel">
      <div className="fs-refine-counts">
        <span className="fs-refine-count fs-refine-count--relevant">{relevant} relevant</span>
        <span className="fs-refine-count fs-refine-count--offtopic">{offTopic} off-topic</span>
        <span className="fs-refine-count fs-refine-count--total">{total} classified</span>
      </div>
      {total < 5 && (
        <div className="fs-refine-hint">Classify at least {5 - total} more result{5 - total !== 1 ? 's' : ''} to enable AI refinement.</div>
      )}
      <button
        className="fs-btn fs-btn--refine"
        onClick={onRefine}
        disabled={!canRefine}
        title={canRefine ? 'Refine query based on your feedback' : `Need ${5 - total} more classifications`}
      >
        {loading ? <Loader size={14} className="fs-spin" /> : <RefreshCw size={14} />}
        {loading ? 'Refining…' : 'Refine Query with AI'}
      </button>
    </div>
  );
}
